import React from "react";
import { Link } from "react-router-dom";

const DeleteModal = (props) => {
  return (
    <>
      {/* Delete Performance Indicator Modal */}
      <div className="modal custom-modal fade" id="delete" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>{props.Name}</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  <div className="col-6">
                    <Link to="#" className="btn btn-primary continue-btn">
                      Delete
                    </Link>
                  </div>
                  <div className="col-6">
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-primary cancel-btn"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Performance Indicator Modal */}
    </>
  );
};

export default DeleteModal;

// import React from "react";
// import { Link } from "react-router-dom";

// const DeleteModal = ({ id, Name, onDelete }) => {
//   const handleDelete = () => {
//     // Fetch current items from localStorage
//     const storedItems = JSON.parse(localStorage.getItem("holidays")) || [];

//     // Filter out the item with the specified id
//     const updatedItems = storedItems.filter((item) => item.id !== id);

//     // Update localStorage with the new list
//     localStorage.setItem("holidays", JSON.stringify(updatedItems));

//     // Call the parent delete handler to update the UI
//     if (onDelete) onDelete(id);
//   };

//   return (
//     <div className="modal custom-modal fade" id="delete" role="dialog">
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content">
//           <div className="modal-body">
//             <div className="form-header">
//               <h3>{Name}</h3>
//               <p>Are you sure want to delete?</p>
//             </div>
//             <div className="modal-btn delete-action">
//               <div className="row">
//                 <div className="col-6">
//                   <Link
//                     to="#"
//                     className="btn btn-primary continue-btn"
//                     onClick={handleDelete}
//                     data-bs-dismiss="modal"
//                   >
//                     Delete
//                   </Link>
//                 </div>
//                 <div className="col-6">
//                   <Link
//                     to="#"
//                     data-bs-dismiss="modal"
//                     className="btn btn-primary cancel-btn"
//                   >
//                     Cancel
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DeleteModal;
